import React, { useEffect, useRef,useState} from 'react';
// import cloudinary from 'cloudinary-video-player';
import classNames from 'classnames';
import css from './VideoPlayer.module.css';
import IconCollection from '../IconCollection/IconCollection';
import Button from '../Button/Button';
if (typeof window !== 'undefined') {
    const cloudinary = require('cloudinary-video-player');
}
import "../../assets/cloud.css";

// Cross shaped button on the top-right corner of the image thumbnail
const RemoveImageButton = props => {
    const { onClick } = props;
    const classes = classNames(css.removeImage);
    return (
        <Button type='button' className={classes} onClick={onClick}>
            <IconCollection iconName={"videoRemoveIcon"} />
        </Button>
    );
};



const VideoPlayer = ({ id, publicId, onRemoveVideo, showRemoveButton=false, listingPage=false, ...props }) => {
    const cloudinaryRef = useRef();
    const playerRef = useRef();
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        if (cloudinaryRef.current) return;

        cloudinaryRef.current = cloudinary;

        const player = cloudinaryRef.current.videoPlayer(playerRef.current, {
            cloud_name: process.env.REACT_APP_CLOUD_NAME,
            secure: true,
            controls: true,
            showLogo: false,
            controlBar: {
                fullscreenToggle: false, // Disable the fullscreen button
                playToggle: true, // Enable play/pause button
                currentTimeDisplay: true, // Hide current time display
                progressControl: false, // Hide progress bar
                volumePanel: false, // Hide volume controls
                remainingTimeDisplay: false, // Hide remaining time
                playbackRateMenuButton: false, // Hide playback rate controls
            }
        });

        // add the source here.
        player.source(publicId);

        // On video end.
        player.on('ended', () => {
            // Reset the video to the beginning
            player.currentTime(0);
        });

    }, [publicId]);

    const handlePlay = () => {
        const video = document.getElementById('videoPlayer_html5_api');
        if (video) {
          video.play();
          setIsPlaying(true);
        }
      };

    return (
        <div className={css.videoCover}>
        <video
            ref={playerRef}
            id={id}
            className="cld-video-player cld-fluid"
            {...props}
        />
        {showRemoveButton ? <RemoveImageButton onClick={() => onRemoveVideo()} /> : null}
       
        {!isPlaying && listingPage && (
             <div className={css.overlay}  onClick={handlePlay}>
             <span className={css.playButton}  onClick={handlePlay}>
               <IconCollection iconName="PLAY_BUTTON" />
             </span>
           </div>
        )}
        
    </div>
    );
};

export default VideoPlayer;